import React, { useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FaConciergeBell, FaUtensils, FaShuttleVan, FaSpa, FaBed } from "react-icons/fa";

// Import Local Video (Replace with actual video file in your assets folder)
import homeVideo from '../assets/Home/WhatsApp Video 2025-02-10 at 10.30.53.mp4';

// Import Villa & Spa Images (Update paths to match actual files)
import villaImage1 from '../assets/Home/DSC_0296.JPG';
import villaImage2 from '../assets/Home/DSC_0326.JPG';

// Import Apartment Images
import apartmentImage1 from '../assets/Home/DSC_0498.JPG';
import apartmentImage2 from '../assets/Home/DSC_0539.JPG';

import spaImage from '../assets/Home/22.jpeg';
import villaImage from '../assets/Home/f2.jpg';

import spaGalleryImage from '../assets/Home/DSC_0326.JPG'; // Replace with actual paths
import villaGalleryImage from '../assets/Home/DSC_0594.JPG';
import toursGalleryImage from '../assets/Home/IMG_9638.jpg';

import contactBackgroundImage from '../assets/Home/3.jpg';
import zelonaToursImage from '../assets/Home/logo.png';

const GoogleReviews = () => {
    useEffect(() => {
        const script = document.createElement('script');
        script.src = "https://static.elfsight.com/platform/platform.js";
        script.async = true;
        document.body.appendChild(script);
    }, []);

    return (
        <section className="container my-5">
            <div className="row text-center">
                <h2 className="fw-bold display-5 mb-4" style={{ color: '#819371' }}>Our Guests say in Google</h2>
                <div className="col-12">
                    <div className="elfsight-app-b8b90cfc-c4d6-48aa-bf07-8075a8422c85" data-elfsight-app-lazy></div>
                </div>
            </div>
        </section>
    );
};

const Home = () => {
    const GalleryCard = ({ image, title, description, link }) => {
        return (
            <div className="position-relative overflow-hidden rounded-4 shadow-lg gallery-card">
                <img src={image} alt={title} className="img-fluid w-100 gallery-img" />
                <div className="position-absolute top-0 start-0 w-100 h-100 gallery-overlay"></div>
                <div className="position-absolute top-50 start-50 translate-middle text-white text-center gallery-text">
                    <h2 className="fw-bold text-uppercase gallery-title">{title}</h2>
                    <p className="mt-2 fs-5 gallery-desc">{description}</p>
                    <a href={link} className="btn btn-light btn-lg mt-3 gallery-btn">View More</a>
                </div>
            </div>
        );
    };

    return (
        <>
            {/* Video Section */}
            <section className="position-relative d-flex align-items-center justify-content-center text-center"
                style={{
                    width: '100%',
                    height: '75vh',
                    overflow: 'hidden'
                }}
            >
                {/* Video Background */}
                <video
                    autoPlay
                    loop
                    muted
                    playsInline
                    className="position-absolute w-100 h-100 object-fit-cover"
                >
                    <source src={homeVideo} type="video/mp4" />
                    Your browser does not support the video tag.
                </video>

                {/* Overlay */}
                <div className="position-absolute top-0 start-0 w-100 h-100 bg-dark bg-opacity-50"></div>

                {/* Centered Content */}
                <div className="position-relative text-white">
                    <h1 className="display-3 fw-bold">Welcome to Cinnamon Mantra</h1>
                    <p className="fs-5 w-75 mx-auto">
                        Experience the ultimate luxury and relaxation with us.
                        Explore the beauty of nature, indulge in Ayurvedic therapies,
                        and enjoy a truly rejuvenating stay.
                    </p>
                </div>
            </section>

            {/* Features Section */}
            <section className="container text-center my-5">
                <p className="text-uppercase fw-bold" style={{ fontSize: '2rem', color: '#819371' }}>
                    Welcome to Cinnamon Mantra
                </p>
                <h2 className="fw-bold display-5">You'll Never Want To Leave</h2>

                {/* Feature Icons */}
                <div className="row justify-content-center mt-4">
                    <div className="col-md-2 col-sm-4 col-6 text-center mb-3">
                        <div className="p-3 shadow-sm rounded bg-light">
                            <FaConciergeBell size={40} className="text-success" />
                            <p className="mt-2 fw-bold">Friendly Service</p>
                        </div>
                    </div>
                    <div className="col-md-2 col-sm-4 col-6 text-center mb-3">
                        <div className="p-3 shadow-sm rounded bg-light">
                            <FaUtensils size={40} className="text-success" />
                            <p className="mt-2 fw-bold">Get Breakfast</p>
                        </div>
                    </div>
                    <div className="col-md-2 col-sm-4 col-6 text-center mb-3">
                        <div className="p-3 shadow-sm rounded bg-light">
                            <FaShuttleVan size={40} className="text-success" />
                            <p className="mt-2 fw-bold">Transfer Services</p>
                        </div>
                    </div>
                    <div className="col-md-2 col-sm-4 col-6 text-center mb-3">
                        <div className="p-3 shadow-sm rounded bg-light">
                            <FaSpa size={40} className="text-success" />
                            <p className="mt-2 fw-bold">Suits & SPA</p>
                        </div>
                    </div>
                    <div className="col-md-2 col-sm-4 col-6 text-center mb-3">
                        <div className="p-3 shadow-sm rounded bg-light">
                            <FaBed size={40} className="text-success" />
                            <p className="mt-2 fw-bold">Cozy Rooms</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Cinnamon Mantra Luxury Villa & Ayurved Spa and Wellness Section */}
            <section className="container my-5">
                <div className="row align-items-center">
                    {/* Left Side - Text */}
                    <div className="col-md-6">
                        <h2 className="fw-bold display-5" style={{ color: '#819371' }}>
                            Cinnamon Mantra Luxury Villa & Ayurved Spa and Wellness
                        </h2>
                        <p className="fs-5 text-muted">
                            Escape into a world of tranquility at Cinnamon Mantra, where luxury meets
                            holistic wellness. Our villa is surrounded by lush landscapes, offering the
                            perfect retreat to relax and rejuvenate.
                        </p>
                        <p className="fs-5 text-muted">
                            Our Ayurvedic spa and wellness center is designed to provide ultimate healing
                            experiences through traditional therapies, herbal treatments, and relaxing massages.
                        </p>
                        <p className="fs-5 text-muted">
                            Whether you're seeking a peaceful vacation, a wellness journey, or a luxurious getaway,
                            Cinnamon Mantra caters to all your needs with personalized services and world-class amenities.
                        </p>
                    </div>

                    {/* Right Side - Images */}
                    <div className="col-md-6 position-relative">
                        <div className="position-relative">
                            <img
                                src={villaImage1}
                                alt="Cinnamon Mantra Luxury Villa"
                                className="img-fluid rounded shadow-lg"
                                style={{ width: '90%', borderRadius: '15px' }}
                            />
                            <img
                                src={villaImage2}
                                alt="Luxury Villa Pool"
                                className="img-fluid rounded shadow-lg position-absolute"
                                style={{
                                    width: '65%',
                                    bottom: '-50px',
                                    left: '40%',
                                    borderRadius: '15px'
                                }}
                            />
                        </div>
                    </div>
                </div>
            </section>

            {/* Luxury Apartments Section */}
            <section className="container" style={{ marginTop: '100px' }}>
                <div className="row">
                    {/* Luxury Apartment Card */}
                    <div className="col-md-6">
                        <div className="position-relative overflow-hidden rounded-4 shadow-lg apartment-card">
                            <img src={apartmentImage1} alt="Luxury Apartment"
                                className="img-fluid w-100 apartment-img" />
                            <div className="position-absolute top-0 start-0 w-100 h-100 apartment-overlay"></div>
                            <div className="position-absolute top-50 start-50 translate-middle text-white text-center apartment-text">
                                <h2 className="fw-bold text-uppercase apartment-title">Luxury Apartment</h2>
                                <p className="mt-2 fs-5 apartment-desc">Experience our beautifully designed luxury apartments with top-tier amenities and breathtaking scenic views.</p>
                                <a href="/apartment-room" className="btn btn-light btn-lg mt-3 apartment-btn">View More</a>
                            </div>
                        </div>
                    </div>

                    {/* Luxury Apartment with Villa Card */}
                    <div className="col-md-6 mt-4 mt-md-0">
                        <div className="position-relative overflow-hidden rounded-4 shadow-lg apartment-card">
                            <img src={apartmentImage2} alt="Luxury Apartment with Villa"
                                className="img-fluid w-100 apartment-img" />
                            <div className="position-absolute top-0 start-0 w-100 h-100 apartment-overlay"></div>
                            <div className="position-absolute top-50 start-50 translate-middle text-white text-center apartment-text">
                                <h2 className="fw-bold text-uppercase apartment-title">Luxury Apartment with Villa</h2>
                                <p className="mt-2 fs-5 apartment-desc">Stay in a luxury apartment within a villa setting, offering the perfect blend of comfort, exclusivity, and modern elegance.</p>
                                <a href="/apartment-rooms-villa" className="btn btn-light btn-lg mt-3 apartment-btn">View More</a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Styles for Hover Effect */}
            <style>
                {`
        .apartment-card {
            transition: transform 0.4s ease-in-out;
            cursor: pointer;
            border-radius: 20px;
            overflow: hidden;
            position: relative;
        }
        .apartment-img {
            height: 400px;
            object-fit: cover;
            filter: brightness(70%);
            transition: filter 0.4s ease-in-out, transform 0.4s ease-in-out;
            border-radius: 20px;
        }
        .apartment-overlay {
            background: rgba(0, 0, 0, 0.5);
            transition: background 0.4s ease-in-out;
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
        }
        .apartment-text {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 85%;
            text-align: center;
            z-index: 2;
        }
        .apartment-title {
            font-size: 2rem;
            text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.5);
            letter-spacing: 1px;
        }
        .apartment-desc {
            font-size: 1.2rem;
            font-weight: 500;
            line-height: 1.6;
            opacity: 0.9;
        }
        .apartment-btn {
            font-size: 1rem;
            padding: 10px 20px;
            font-weight: bold;
            border-radius: 30px;
            transition: all 0.3s ease-in-out;
        }
        .apartment-btn:hover {
            background-color: black !important;
            color: white !important;
            border: 1px solid white !important;
        }
        /* Hover Effects */
        .apartment-card:hover {
            transform: scale(1.03);
        }
        .apartment-card:hover .apartment-img {
            filter: brightness(85%);
        }
        .apartment-card:hover .apartment-overlay {
            background: rgba(255, 255, 255, 0.2);
        }
        .apartment-card:hover .apartment-text {
            color: black !important;
            text-shadow: none;
        }
    `}
            </style>

            {/* Mantra Ayurveda Spa and Wellness Section */}
            <section className="container my-5">
                {/* Section Heading */}
                <h2 className="text-center fw-bold display-5 mb-4" style={{ color: '#819371' }}>
                    Mantra Ayurveda Spa and Wellness
                </h2>

                <div className="row align-items-center">
                    {/* Left Side - Text Content */}
                    <div className="col-md-6">
                        <p className="fs-5 text-muted">
                            At Mantra Ayurveda Spa and Wellness, we believe in the art of rejuvenation.
                            Our therapies blend ancient Ayurvedic wisdom with modern wellness techniques,
                            ensuring a holistic healing experience that restores harmony to the body and mind.
                        </p>
                        <p className="fs-5 text-muted">
                            Indulge in our signature spa treatments, herbal body therapies, and meditation
                            sessions that help you reconnect with your inner self. Whether it's a stress-relief
                            massage or a detoxifying treatment, we promise an unparalleled wellness retreat.
                        </p>
                        <a href="/ayurveda-spa" className="btn btn-success btn-lg mt-3 spa-btn">Read More</a>
                    </div>

                    {/* Right Side - Image */}
                    <div className="col-md-6 text-center mt-4">
                        <div className="position-relative overflow-hidden rounded-4 shadow-lg spa-image">
                            <img src={spaImage} alt="Mantra Ayurveda Spa" className="img-fluid w-100 rounded-4" style={{ height: '500px' }} />
                        </div>
                    </div>
                </div>
            </section>

            {/* Styles for Hover Effect */}
            <style>
                {`
                    .spa-btn {
                        font-size: 1rem;
                        padding: 12px 25px;
                        font-weight: bold;
                        border-radius: 30px;
                        transition: all 0.3s ease-in-out;
                    }
                    .spa-btn:hover {
                        background-color: black !important;
                        color: white !important;
                        border: 1px solid white !important;
                    }
                    .spa-image {
                        transition: transform 0.4s ease-in-out;
                    }
                    .spa-image:hover {
                        transform: scale(1.05);
                    }
                `}
            </style>
            {/* Cinnamon Mantra Luxury Villa Section */}
            <section className="container my-5">
                <h2 className="text-center fw-bold display-5 mb-4" style={{ color: '#819371' }}>
                    Cinnamon Mantra Luxury Villa
                </h2>
                <div className="row align-items-center">
                    {/* Left Side - Image */}
                    <div className="col-md-6 text-center">
                        <div className="position-relative overflow-hidden rounded-4 shadow-lg villa-image">
                            <img src={villaImage} alt="Cinnamon Mantra Luxury Villa" className="img-fluid w-100 rounded-4" />
                        </div>
                    </div>

                    {/* Right Side - Text Content */}
                    <div className="col-md-6 mt-4">

                        <p className="fs-5 text-muted">
                            Cinnamon Mantra Luxury Villa offers a lavish retreat where guests can enjoy
                            a seamless fusion of comfort, luxury, and nature. The villa provides an idyllic setting
                            for families, groups, or couples looking to indulge in a serene getaway.
                        </p>
                        <p className="fs-5 text-muted">
                            With elegant living spaces, breathtaking views, and personalized service, this villa offers
                            a truly extraordinary experience. Whether it's unwinding by the pool, exploring the surroundings,
                            or pampering yourself at the spa, Cinnamon Mantra ensures an unforgettable stay.
                        </p>
                        {/* Read More Button */}
                        <a href="/villa" className="btn btn-success btn-lg mt-3 villa-btn">Read More</a>
                    </div>
                </div>
            </section>

            {/* Styles for Hover Effect */}
            <style>
                {`
                    .villa-image {
                        transition: transform 0.4s ease-in-out;
                    }
                    .villa-image:hover {
                        transform: scale(1.05);
                    }

                    .villa-btn {
                        font-size: 1rem;
                        padding: 12px 25px;
                        font-weight: bold;
                        border-radius: 30px;
                        transition: all 0.3s ease-in-out;
                    }
                    .villa-btn:hover {
                        background-color: black !important;
                        color: white !important;
                        border: 1px solid white !important;
                    }
                `}
            </style>
            <GoogleReviews />

            {/* Existing Sections Below */}

            {/* Elfsight Platform Script */}
            <script src="https://static.elfsight.com/platform/platform.js" async></script>
            {/* Our Gallery Section */}
            <section className="container my-5">
                <h2 className="text-center fw-bold display-5 mb-4" style={{ color: '#819371' }}>Our Gallery</h2>
                <div className="row">
                    <div className="col-md-4 mb-4">
                        <GalleryCard
                            image={spaGalleryImage}
                            title="Ayurveda Spa"
                            description="Experience the ultimate relaxation and rejuvenation with our traditional Ayurvedic treatments."
                            link="/ayurveda-spa"
                        />
                    </div>
                    <div className="col-md-4 mb-4">
                        <GalleryCard
                            image={villaGalleryImage}
                            title="Villa"
                            description="Indulge in the luxurious comfort and breathtaking views of our exquisite villa."
                            link="/villa"
                        />
                    </div>
                    <div className="col-md-4 mb-4">
                        <GalleryCard
                            image={toursGalleryImage}
                            title="Tours"
                            description="Explore the wonders of the surrounding area with our curated selection of exciting tours."
                            link="/tours"
                        />
                    </div>
                </div>

                {/* Styles for Hover Effect */}
                <style>
                    {`
                    .gallery-card {
                        transition: transform 0.4s ease-in-out;
                        cursor: pointer;
                        border-radius: 20px;
                        overflow: hidden;
                        position: relative;
                        height: 350px; /* Set a fixed height for the cards */
                    }

                    .gallery-img {
                        height: 100%; /* Make the image cover the card */
                        object-fit: cover;
                        filter: brightness(70%);
                        transition: filter 0.4s ease-in-out, transform 0.4s ease-in-out;
                        border-radius: 20px;
                    }

                    .gallery-overlay {
                        background: rgba(0, 0, 0, 0.5);
                        transition: background 0.4s ease-in-out;
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                    }

                    .gallery-text {
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        width: 85%;
                        text-align: center;
                        z-index: 2;
                    }

                    .gallery-title {
                        font-size: 1.8rem; /* Slightly smaller title */
                        text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.5);
                        letter-spacing: 1px;
                    }

                    .gallery-desc {
                        font-size: 1rem; /* Slightly smaller description */
                        font-weight: 500;
                        line-height: 1.4; /* Adjust line height */
                        opacity: 0.9;
                    }

                    .gallery-btn {
                        font-size: 1rem;
                        padding: 10px 20px;
                        font-weight: bold;
                        border-radius: 30px;
                        transition: all 0.3s ease-in-out;
                    }

                    .gallery-btn:hover {
                        background-color: black !important;
                        color: white !important;
                        border: 1px solid white !important;
                    }

                    /* Hover Effects */
                    .gallery-card:hover {
                        transform: scale(1.03);
                    }

                    .gallery-card:hover .gallery-img {
                        filter: brightness(85%);
                    }

                    .gallery-card:hover .gallery-overlay {
                        background: rgba(255, 255, 255, 0.2);
                    }

                    .gallery-card:hover .gallery-text {
                        color: black !important;
                        text-shadow: none;
                    }

                    `}
                </style>
            </section>
            {/* Contact Us Section */}
            <section className="position-relative contact-section" style={{
                backgroundImage: `url(${contactBackgroundImage})`, // Set background image
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                padding: '100px 0', // Add some padding
                height: '50vh', // Set a minimum height
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
                color: 'white' // Set default text color to white
            }}>
                <div className="position-absolute top-0 start-0 w-100 h-100 contact-overlay"></div> {/* Overlay */}
                <div className="position-relative contact-content" style={{ zIndex: 1 }}> {/* Content container with higher z-index */}
                    <h2 className="fw-bold display-5 mb-3">Get in touch with us</h2>
                    <p className="fs-5 w-75 mx-auto mb-4">
                        We'd love to hear from you!  Whether you have questions about our services,
                        want to book a stay, or simply want to say hello, please don't hesitate to reach out.
                    </p>
                    <a href="/contact-us" className="btn btn-light btn-lg contact-button">Contact Us</a>
                </div>
            </section>

            {/* Style for Contact Section */}
            <style>
                {`
                    .contact-overlay {
                        background-color: rgba(0, 0, 0, 0.5); /* Semi-transparent black overlay */
                    }

                    .contact-content {
                        /* Styles for the content container */
                        width: 80%; /* Adjust width as needed */
                        max-width: 900px;
                    }

                    .contact-button {
                        background-color: transparent !important; /* Transparent background */
                        border: 2px solid white !important; /* White border */
                        color: white !important; /* White text */
                        transition: all 0.3s ease-in-out;
                    }

                    .contact-button:hover {
                        background-color: white !important; /* White background on hover */
                        color: black !important; /* Black text on hover */
                    }

                    .contact-section {
                        /* Other existing styles */
                    }
                `}
            </style>
            {/* Our Other Companies Section */}
            <section className="container my-5">
                <h2 className="text-center fw-bold display-5 mb-4" style={{ color: '#819371' }}>
                    Our Other Companies
                </h2>
                <div className="row align-items-center">
                    {/* Left Side - Image */}
                    <div className="col-md-6 text-center">
                        <div className="position-relative overflow-hidden rounded-4 shadow-lg other-companies-image">
                            <img
                                src={zelonaToursImage}
                                alt="Zelona Tours"
                                className="img-fluid rounded-4 zelona-image"
                            />
                        </div>
                    </div>

                    {/* Right Side - Text Content */}
                    <div className="col-md-6 mt-4">
                        <h3 className="fw-bold" style={{ color: '#819371' }}>Zelona Tours</h3>
                        <h4 className="fw-bold" style={{ color: '#819371' }}>www.zelonatours.com</h4>
                        <p className="fs-5 text-muted">
                            Zelona Tours specializes in creating unforgettable travel experiences, with a particular focus on showcasing the beauty and diversity of Sri Lanka. We offer a wide range of curated tours, from adventurous explorations of exotic destinations within Sri Lanka to relaxing getaways in serene locations across the island.  Whether you're interested in exploring ancient ruins, trekking through lush tea plantations, relaxing on pristine beaches, or experiencing the vibrant culture of Sri Lanka, we have a tour designed for you. Our expert team is dedicated to crafting personalized itineraries that cater to your unique interests and preferences, ensuring a seamless and enriching journey.  We utilize luxury transport systems to enhance your travel experience, allowing you to explore Sri Lanka in comfort and style. Discover the wonders of Sri Lanka with Zelona Tours and create memories that will last a lifetime.
                        </p>
                    </div>
                </div>
            </section>


            <style>
                {`
    .other-companies-image {
        transition: transform 0.4s ease-in-out;
        max-width: 400px; /* Set maximum width for the container */
        
        margin: 0 auto; /* Center the image */
    }

    .zelona-image {
        width: 100%; /* Make image responsive within container */
        height: 400px; /* Fixed height */
        object-fit: cover; /* Maintain aspect ratio */
    }

    .other-companies-image:hover {
        transform: scale(1.05);
    }

    @media (max-width: 767px) {
        .zelona-image {
            height: 200px; /* Smaller height for mobile */
        }
        .other-companies-image {
            max-width: 200px; /* Smaller width for mobile */
        }
    }
    `}
            </style>

        </>
    );
};

export default Home;